__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/a6cfeee/_next/";